import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isIos } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.JailbrokenDevice
const label = visitFilterLabelMap[key]

export const jailbrokenColumn = () =>
  columnHelper.display({
    id: 'jailbroken',
    header: 'Jailbroken Device',
    cell: ({ row }) => {
      if (!isIos(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.jailbroken

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
